/** Phân quyền — trang chủ / dashboard */
export const DASHBOARD_PERMISSION_CODES = {
  WEB_BH_DASHBOARD_LIST: 'WEB_BH_DASHBOARD_LIST',
} as const

export type DashboardPermissionCode =
  (typeof DASHBOARD_PERMISSION_CODES)[keyof typeof DASHBOARD_PERMISSION_CODES]

export const dashboardPermissionCodeValues = Object.values(DASHBOARD_PERMISSION_CODES)

export const DASHBOARD_READ_PERMISSIONS = [
  DASHBOARD_PERMISSION_CODES.WEB_BH_DASHBOARD_LIST,
] as const
